// Small inline SVG icons (stroke style, inherit text color)
const iconProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export const FilterIcon = ({ className = "btn-icon" }) => (
  <svg {...iconProps} className={className}>
    <path d="M3 5h18l-7 8.5V19l-4 2v-7.5L3 5z" />
  </svg>
);

export const DownloadIcon = ({ className = "btn-icon" }) => (
  <svg {...iconProps} className={className}>
    <path d="M12 3v12" />
    <path d="M7 10l5 5 5-5" />
    <path d="M5 21h14" />
  </svg>
);

export const MailIcon = ({ className = "btn-icon" }) => (
  <svg {...iconProps} className={className}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);
